import React, {Component} from 'react';
import {connect} from "react-redux";
import {Container, Image} from 'react-bootstrap'
import {BsArrowLeft} from 'react-icons/bs'
import {withTranslation} from 'react-i18next';

import logo from './images/logo.png'

import './layout.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import {compose} from "../../utils";
import queryString from "query-string";
import withRouter from "../hoc/with-router";

class Layout extends Component {
    renderBackUrl = () => {
        const {t, app: {data: {backUrl:backToShopUrl, fromSite}}} = this.props
        const {location} = this.props
        const queryParams = queryString.parse(location.search)

        let backUrlLabel = t("backToMain")
        let backUrl = backToShopUrl

        if (!fromSite || (queryParams.backUrl!==undefined && queryParams.backUrl!=="")) {
            backUrl = queryParams.backUrl
            backUrlLabel = t("backToShop")
        }

        return <a href={backUrl} className="apay-backurl"><BsArrowLeft/> {backUrlLabel}</a>
    }

    render() {
        return (<div className="d-flex flex-column justify-content-between min-vh-100">
                <div className="d-flex flex-column justify-content-between">
                    <div className="apay-header">
                        <Container>
                            <div className="d-flex flex-row justify-content-between">
                                <div className="apay-logo">
                                    <a href="https://www.airbapay.kz/">
                                        <Image src={logo} rounded/>
                                    </a>
                                </div>
                                <div>
                                    {this.renderBackUrl()}
                                </div>
                            </div>
                        </Container>
                    </div>
                    <div className="apay-content">
                        {this.props.children}

                    </div>
                </div>
                <div className="apay-footer">
                    <Container>
                        <div className="apay-copyright">© «Airba» 2021</div>
                    </Container>
                </div>
            </div>)
    }
}

const mapStateToProps = ({app}) => {
    return {
        app
    }
}
export default compose(withTranslation(), withRouter(), connect(mapStateToProps))(Layout);